(function () {
/* eslint-disable prettier/prettier */ /* eslint-disable prettier/prettier */ const $486fa63a7f16da4a$var$historyItems = document.querySelectorAll('.timeline--item');
const $486fa63a7f16da4a$var$containerElem = document.querySelector('.timeline--content');
const $486fa63a7f16da4a$var$nextBtn = document.querySelector('.timeline--controls--next');
const $486fa63a7f16da4a$var$prevBtn = document.querySelector('.timeline--controls--prev');
const $486fa63a7f16da4a$var$scrollToItem = (el)=>{
    if (window.innerWidth < 900) el.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
    });
    else el.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
    });
};
const $486fa63a7f16da4a$var$scrollNext = ()=>{
    $486fa63a7f16da4a$var$containerElem.scroll({
        top: 0,
        left: $486fa63a7f16da4a$var$containerElem.scrollLeft + 304,
        behavior: 'smooth'
    });
};
const $486fa63a7f16da4a$var$scrollPrev = ()=>{
    $486fa63a7f16da4a$var$containerElem.scroll({
        top: 0,
        left: $486fa63a7f16da4a$var$containerElem.scrollLeft - 304,
        behavior: 'smooth'
    });
};
function $486fa63a7f16da4a$export$2e2bcd8739ae039() {
// if (historyItems.length > 0)
// {
//     historyItems.forEach(item => {
//         item.addEventListener('mouseover', () => {
//             scrollToItem(item)
//         })
//         item.querySelector('button').addEventListener('focus', () => {
//             scrollToItem(item)
//         })
//     })
// }
// if (nextBtn)
// {
//     nextBtn.addEventListener('click', scrollNext)
// }
// if (prevBtn)
// {
//     prevBtn.addEventListener('click', scrollPrev)
// }
}


// packages/alpinejs/src/scheduler.js
var $79c742c8182c44e1$var$flushPending = false;
var $79c742c8182c44e1$var$flushing = false;
var $79c742c8182c44e1$var$queue = [];
var $79c742c8182c44e1$var$lastFlushedIndex = -1;
function $79c742c8182c44e1$var$scheduler(callback) {
    $79c742c8182c44e1$var$queueJob(callback);
}
function $79c742c8182c44e1$var$queueJob(job) {
    if (!$79c742c8182c44e1$var$queue.includes(job)) $79c742c8182c44e1$var$queue.push(job);
    $79c742c8182c44e1$var$queueFlush();
}
function $79c742c8182c44e1$var$dequeueJob(job) {
    let index = $79c742c8182c44e1$var$queue.indexOf(job);
    if (index !== -1 && index > $79c742c8182c44e1$var$lastFlushedIndex) $79c742c8182c44e1$var$queue.splice(index, 1);
}
function $79c742c8182c44e1$var$queueFlush() {
    if (!$79c742c8182c44e1$var$flushing && !$79c742c8182c44e1$var$flushPending) {
        $79c742c8182c44e1$var$flushPending = true;
        queueMicrotask($79c742c8182c44e1$var$flushJobs);
    }
}
function $79c742c8182c44e1$var$flushJobs() {
    $79c742c8182c44e1$var$flushPending = false;
    $79c742c8182c44e1$var$flushing = true;
    for(let i = 0; i < $79c742c8182c44e1$var$queue.length; i++){
        $79c742c8182c44e1$var$queue[i]();
        $79c742c8182c44e1$var$lastFlushedIndex = i;
    }
    $79c742c8182c44e1$var$queue.length = 0;
    $79c742c8182c44e1$var$lastFlushedIndex = -1;
    $79c742c8182c44e1$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $79c742c8182c44e1$var$reactive;
var $79c742c8182c44e1$var$effect;
var $79c742c8182c44e1$var$release;
var $79c742c8182c44e1$var$raw;
var $79c742c8182c44e1$var$shouldSchedule = true;
function $79c742c8182c44e1$var$disableEffectScheduling(callback) {
    $79c742c8182c44e1$var$shouldSchedule = false;
    callback();
    $79c742c8182c44e1$var$shouldSchedule = true;
}
function $79c742c8182c44e1$var$setReactivityEngine(engine) {
    $79c742c8182c44e1$var$reactive = engine.reactive;
    $79c742c8182c44e1$var$release = engine.release;
    $79c742c8182c44e1$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($79c742c8182c44e1$var$shouldSchedule) $79c742c8182c44e1$var$scheduler(task);
                else task();
            }
        });
    $79c742c8182c44e1$var$raw = engine.raw;
}
function $79c742c8182c44e1$var$overrideEffect(override) {
    $79c742c8182c44e1$var$effect = override;
}
function $79c742c8182c44e1$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $79c742c8182c44e1$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $79c742c8182c44e1$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $79c742c8182c44e1$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $79c742c8182c44e1$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$79c742c8182c44e1$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $79c742c8182c44e1$var$onAttributeAddeds = [];
var $79c742c8182c44e1$var$onElRemoveds = [];
var $79c742c8182c44e1$var$onElAddeds = [];
function $79c742c8182c44e1$var$onElAdded(callback) {
    $79c742c8182c44e1$var$onElAddeds.push(callback);
}
function $79c742c8182c44e1$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $79c742c8182c44e1$var$onElRemoveds.push(callback);
    }
}
function $79c742c8182c44e1$var$onAttributesAdded(callback) {
    $79c742c8182c44e1$var$onAttributeAddeds.push(callback);
}
function $79c742c8182c44e1$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $79c742c8182c44e1$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $79c742c8182c44e1$var$cleanupElement(el) {
    el._x_effects?.forEach($79c742c8182c44e1$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $79c742c8182c44e1$var$observer = new MutationObserver($79c742c8182c44e1$var$onMutate);
var $79c742c8182c44e1$var$currentlyObserving = false;
function $79c742c8182c44e1$var$startObservingMutations() {
    $79c742c8182c44e1$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $79c742c8182c44e1$var$currentlyObserving = true;
}
function $79c742c8182c44e1$var$stopObservingMutations() {
    $79c742c8182c44e1$var$flushObserver();
    $79c742c8182c44e1$var$observer.disconnect();
    $79c742c8182c44e1$var$currentlyObserving = false;
}
var $79c742c8182c44e1$var$queuedMutations = [];
function $79c742c8182c44e1$var$flushObserver() {
    let records = $79c742c8182c44e1$var$observer.takeRecords();
    $79c742c8182c44e1$var$queuedMutations.push(()=>records.length > 0 && $79c742c8182c44e1$var$onMutate(records));
    let queueLengthWhenTriggered = $79c742c8182c44e1$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($79c742c8182c44e1$var$queuedMutations.length === queueLengthWhenTriggered) while($79c742c8182c44e1$var$queuedMutations.length > 0)$79c742c8182c44e1$var$queuedMutations.shift()();
    });
}
function $79c742c8182c44e1$var$mutateDom(callback) {
    if (!$79c742c8182c44e1$var$currentlyObserving) return callback();
    $79c742c8182c44e1$var$stopObservingMutations();
    let result = callback();
    $79c742c8182c44e1$var$startObservingMutations();
    return result;
}
var $79c742c8182c44e1$var$isCollecting = false;
var $79c742c8182c44e1$var$deferredMutations = [];
function $79c742c8182c44e1$var$deferMutations() {
    $79c742c8182c44e1$var$isCollecting = true;
}
function $79c742c8182c44e1$var$flushAndStopDeferringMutations() {
    $79c742c8182c44e1$var$isCollecting = false;
    $79c742c8182c44e1$var$onMutate($79c742c8182c44e1$var$deferredMutations);
    $79c742c8182c44e1$var$deferredMutations = [];
}
function $79c742c8182c44e1$var$onMutate(mutations) {
    if ($79c742c8182c44e1$var$isCollecting) {
        $79c742c8182c44e1$var$deferredMutations = $79c742c8182c44e1$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = /* @__PURE__ */ new Set();
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.add(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.add(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $79c742c8182c44e1$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $79c742c8182c44e1$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.has(node)) continue;
        $79c742c8182c44e1$var$onElRemoveds.forEach((i)=>i(node));
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.has(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $79c742c8182c44e1$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $79c742c8182c44e1$var$scope(node) {
    return $79c742c8182c44e1$var$mergeProxies($79c742c8182c44e1$var$closestDataStack(node));
}
function $79c742c8182c44e1$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$79c742c8182c44e1$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $79c742c8182c44e1$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $79c742c8182c44e1$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $79c742c8182c44e1$var$closestDataStack(node.parentNode);
}
function $79c742c8182c44e1$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $79c742c8182c44e1$var$mergeProxyTrap);
}
var $79c742c8182c44e1$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $79c742c8182c44e1$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $79c742c8182c44e1$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $79c742c8182c44e1$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $79c742c8182c44e1$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$79c742c8182c44e1$var$get(data2, path), (value)=>$79c742c8182c44e1$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $79c742c8182c44e1$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $79c742c8182c44e1$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $79c742c8182c44e1$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $79c742c8182c44e1$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $79c742c8182c44e1$var$magics = {};
function $79c742c8182c44e1$var$magic(name, callback) {
    $79c742c8182c44e1$var$magics[name] = callback;
}
function $79c742c8182c44e1$var$injectMagics(obj, el) {
    let memoizedUtilities = $79c742c8182c44e1$var$getUtilities(el);
    Object.entries($79c742c8182c44e1$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $79c742c8182c44e1$var$getUtilities(el) {
    let [utilities, cleanup2] = $79c742c8182c44e1$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $79c742c8182c44e1$var$interceptor,
        ...utilities
    };
    $79c742c8182c44e1$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $79c742c8182c44e1$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $79c742c8182c44e1$var$handleError(e, el, expression);
    }
}
function $79c742c8182c44e1$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $79c742c8182c44e1$var$shouldAutoEvaluateFunctions = true;
function $79c742c8182c44e1$var$dontAutoEvaluateFunctions(callback) {
    let cache = $79c742c8182c44e1$var$shouldAutoEvaluateFunctions;
    $79c742c8182c44e1$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $79c742c8182c44e1$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $79c742c8182c44e1$var$evaluate(el, expression, extras = {}) {
    let result;
    $79c742c8182c44e1$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $79c742c8182c44e1$var$evaluateLater(...args) {
    return $79c742c8182c44e1$var$theEvaluatorFunction(...args);
}
var $79c742c8182c44e1$var$theEvaluatorFunction = $79c742c8182c44e1$var$normalEvaluator;
function $79c742c8182c44e1$var$setEvaluator(newEvaluator) {
    $79c742c8182c44e1$var$theEvaluatorFunction = newEvaluator;
}
function $79c742c8182c44e1$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $79c742c8182c44e1$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$79c742c8182c44e1$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $79c742c8182c44e1$var$generateEvaluatorFromFunction(dataStack, expression) : $79c742c8182c44e1$var$generateEvaluatorFromString(dataStack, expression, el);
    return $79c742c8182c44e1$var$tryCatch.bind(null, el, expression, evaluator);
}
function $79c742c8182c44e1$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($79c742c8182c44e1$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $79c742c8182c44e1$var$runIfTypeOfFunction(receiver, result);
    };
}
var $79c742c8182c44e1$var$evaluatorMemo = {};
function $79c742c8182c44e1$var$generateFunctionFromString(expression, el) {
    if ($79c742c8182c44e1$var$evaluatorMemo[expression]) return $79c742c8182c44e1$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $79c742c8182c44e1$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $79c742c8182c44e1$var$evaluatorMemo[expression] = func;
    return func;
}
function $79c742c8182c44e1$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $79c742c8182c44e1$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $79c742c8182c44e1$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$79c742c8182c44e1$var$handleError(error2, el, expression));
            if (func.finished) {
                $79c742c8182c44e1$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $79c742c8182c44e1$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$79c742c8182c44e1$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $79c742c8182c44e1$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($79c742c8182c44e1$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$79c742c8182c44e1$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$79c742c8182c44e1$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $79c742c8182c44e1$var$prefixAsString = "x-";
function $79c742c8182c44e1$var$prefix(subject = "") {
    return $79c742c8182c44e1$var$prefixAsString + subject;
}
function $79c742c8182c44e1$var$setPrefix(newPrefix) {
    $79c742c8182c44e1$var$prefixAsString = newPrefix;
}
var $79c742c8182c44e1$var$directiveHandlers = {};
function $79c742c8182c44e1$var$directive(name, callback) {
    $79c742c8182c44e1$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$79c742c8182c44e1$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $79c742c8182c44e1$var$directiveOrder.indexOf(directive2);
            $79c742c8182c44e1$var$directiveOrder.splice(pos >= 0 ? pos : $79c742c8182c44e1$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $79c742c8182c44e1$var$directiveExists(name) {
    return Object.keys($79c742c8182c44e1$var$directiveHandlers).includes(name);
}
function $79c742c8182c44e1$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $79c742c8182c44e1$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($79c742c8182c44e1$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($79c742c8182c44e1$var$outNonAlpineAttributes).map($79c742c8182c44e1$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($79c742c8182c44e1$var$byPriority);
    return directives2.map((directive2)=>{
        return $79c742c8182c44e1$var$getDirectiveHandler(el, directive2);
    });
}
function $79c742c8182c44e1$var$attributesOnly(attributes) {
    return Array.from(attributes).map($79c742c8182c44e1$var$toTransformedAttributes()).filter((attr)=>!$79c742c8182c44e1$var$outNonAlpineAttributes(attr));
}
var $79c742c8182c44e1$var$isDeferringHandlers = false;
var $79c742c8182c44e1$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $79c742c8182c44e1$var$currentHandlerStackKey = Symbol();
function $79c742c8182c44e1$var$deferHandlingDirectives(callback) {
    $79c742c8182c44e1$var$isDeferringHandlers = true;
    let key = Symbol();
    $79c742c8182c44e1$var$currentHandlerStackKey = key;
    $79c742c8182c44e1$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($79c742c8182c44e1$var$directiveHandlerStacks.get(key).length)$79c742c8182c44e1$var$directiveHandlerStacks.get(key).shift()();
        $79c742c8182c44e1$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $79c742c8182c44e1$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $79c742c8182c44e1$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $79c742c8182c44e1$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $79c742c8182c44e1$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $79c742c8182c44e1$var$evaluateLater.bind($79c742c8182c44e1$var$evaluateLater, el),
        evaluate: $79c742c8182c44e1$var$evaluate.bind($79c742c8182c44e1$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $79c742c8182c44e1$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $79c742c8182c44e1$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $79c742c8182c44e1$var$getElementBoundUtilities(el);
    $79c742c8182c44e1$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $79c742c8182c44e1$var$isDeferringHandlers ? $79c742c8182c44e1$var$directiveHandlerStacks.get($79c742c8182c44e1$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $79c742c8182c44e1$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $79c742c8182c44e1$var$into = (i)=>i;
function $79c742c8182c44e1$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $79c742c8182c44e1$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $79c742c8182c44e1$var$attributeTransformers = [];
function $79c742c8182c44e1$var$mapAttributes(callback) {
    $79c742c8182c44e1$var$attributeTransformers.push(callback);
}
function $79c742c8182c44e1$var$outNonAlpineAttributes({ name: name }) {
    return $79c742c8182c44e1$var$alpineAttributeRegex().test(name);
}
var $79c742c8182c44e1$var$alpineAttributeRegex = ()=>new RegExp(`^${$79c742c8182c44e1$var$prefixAsString}([^:^.]+)\\b`);
function $79c742c8182c44e1$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($79c742c8182c44e1$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $79c742c8182c44e1$var$DEFAULT = "DEFAULT";
var $79c742c8182c44e1$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $79c742c8182c44e1$var$DEFAULT,
    "teleport"
];
function $79c742c8182c44e1$var$byPriority(a, b) {
    let typeA = $79c742c8182c44e1$var$directiveOrder.indexOf(a.type) === -1 ? $79c742c8182c44e1$var$DEFAULT : a.type;
    let typeB = $79c742c8182c44e1$var$directiveOrder.indexOf(b.type) === -1 ? $79c742c8182c44e1$var$DEFAULT : b.type;
    return $79c742c8182c44e1$var$directiveOrder.indexOf(typeA) - $79c742c8182c44e1$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $79c742c8182c44e1$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $79c742c8182c44e1$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$79c742c8182c44e1$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $79c742c8182c44e1$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $79c742c8182c44e1$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $79c742c8182c44e1$var$started = false;
function $79c742c8182c44e1$var$start() {
    if ($79c742c8182c44e1$var$started) $79c742c8182c44e1$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $79c742c8182c44e1$var$started = true;
    if (!document.body) $79c742c8182c44e1$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $79c742c8182c44e1$var$dispatch(document, "alpine:init");
    $79c742c8182c44e1$var$dispatch(document, "alpine:initializing");
    $79c742c8182c44e1$var$startObservingMutations();
    $79c742c8182c44e1$var$onElAdded((el)=>$79c742c8182c44e1$var$initTree(el, $79c742c8182c44e1$var$walk));
    $79c742c8182c44e1$var$onElRemoved((el)=>$79c742c8182c44e1$var$destroyTree(el));
    $79c742c8182c44e1$var$onAttributesAdded((el, attrs)=>{
        $79c742c8182c44e1$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$79c742c8182c44e1$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($79c742c8182c44e1$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $79c742c8182c44e1$var$initTree(el);
    });
    $79c742c8182c44e1$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $79c742c8182c44e1$var$warnAboutMissingPlugins();
    });
}
var $79c742c8182c44e1$var$rootSelectorCallbacks = [];
var $79c742c8182c44e1$var$initSelectorCallbacks = [];
function $79c742c8182c44e1$var$rootSelectors() {
    return $79c742c8182c44e1$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $79c742c8182c44e1$var$allSelectors() {
    return $79c742c8182c44e1$var$rootSelectorCallbacks.concat($79c742c8182c44e1$var$initSelectorCallbacks).map((fn)=>fn());
}
function $79c742c8182c44e1$var$addRootSelector(selectorCallback) {
    $79c742c8182c44e1$var$rootSelectorCallbacks.push(selectorCallback);
}
function $79c742c8182c44e1$var$addInitSelector(selectorCallback) {
    $79c742c8182c44e1$var$initSelectorCallbacks.push(selectorCallback);
}
function $79c742c8182c44e1$var$closestRoot(el, includeInitSelectors = false) {
    return $79c742c8182c44e1$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $79c742c8182c44e1$var$allSelectors() : $79c742c8182c44e1$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $79c742c8182c44e1$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $79c742c8182c44e1$var$findClosest(el.parentElement, callback);
}
function $79c742c8182c44e1$var$isRoot(el) {
    return $79c742c8182c44e1$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $79c742c8182c44e1$var$initInterceptors2 = [];
function $79c742c8182c44e1$var$interceptInit(callback) {
    $79c742c8182c44e1$var$initInterceptors2.push(callback);
}
function $79c742c8182c44e1$var$initTree(el, walker = $79c742c8182c44e1$var$walk, intercept = ()=>{}) {
    $79c742c8182c44e1$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $79c742c8182c44e1$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $79c742c8182c44e1$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $79c742c8182c44e1$var$destroyTree(root, walker = $79c742c8182c44e1$var$walk) {
    walker(root, (el)=>{
        $79c742c8182c44e1$var$cleanupElement(el);
        $79c742c8182c44e1$var$cleanupAttributes(el);
    });
}
function $79c742c8182c44e1$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($79c742c8182c44e1$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $79c742c8182c44e1$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $79c742c8182c44e1$var$tickStack = [];
var $79c742c8182c44e1$var$isHolding = false;
function $79c742c8182c44e1$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $79c742c8182c44e1$var$isHolding || setTimeout(()=>{
            $79c742c8182c44e1$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $79c742c8182c44e1$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $79c742c8182c44e1$var$releaseNextTicks() {
    $79c742c8182c44e1$var$isHolding = false;
    while($79c742c8182c44e1$var$tickStack.length)$79c742c8182c44e1$var$tickStack.shift()();
}
function $79c742c8182c44e1$var$holdNextTicks() {
    $79c742c8182c44e1$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $79c742c8182c44e1$var$setClasses(el, value) {
    if (Array.isArray(value)) return $79c742c8182c44e1$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $79c742c8182c44e1$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $79c742c8182c44e1$var$setClasses(el, value());
    return $79c742c8182c44e1$var$setClassesFromString(el, value);
}
function $79c742c8182c44e1$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $79c742c8182c44e1$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $79c742c8182c44e1$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $79c742c8182c44e1$var$setStylesFromObject(el, value);
    return $79c742c8182c44e1$var$setStylesFromString(el, value);
}
function $79c742c8182c44e1$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $79c742c8182c44e1$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $79c742c8182c44e1$var$setStyles(el, previousStyles);
    };
}
function $79c742c8182c44e1$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $79c742c8182c44e1$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $79c742c8182c44e1$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$79c742c8182c44e1$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $79c742c8182c44e1$var$registerTransitionsFromHelper(el, modifiers, value);
    else $79c742c8182c44e1$var$registerTransitionsFromClassString(el, expression, value);
});
function $79c742c8182c44e1$var$registerTransitionsFromClassString(el, classString, stage) {
    $79c742c8182c44e1$var$registerTransitionObject(el, $79c742c8182c44e1$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $79c742c8182c44e1$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $79c742c8182c44e1$var$registerTransitionObject(el, $79c742c8182c44e1$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $79c742c8182c44e1$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $79c742c8182c44e1$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $79c742c8182c44e1$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $79c742c8182c44e1$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $79c742c8182c44e1$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $79c742c8182c44e1$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $79c742c8182c44e1$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $79c742c8182c44e1$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $79c742c8182c44e1$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $79c742c8182c44e1$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $79c742c8182c44e1$var$closestHide(parent);
}
function $79c742c8182c44e1$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $79c742c8182c44e1$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $79c742c8182c44e1$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $79c742c8182c44e1$var$once(()=>{
        $79c742c8182c44e1$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $79c742c8182c44e1$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $79c742c8182c44e1$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $79c742c8182c44e1$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $79c742c8182c44e1$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $79c742c8182c44e1$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $79c742c8182c44e1$var$mutateDom(()=>{
                stages.end();
            });
            $79c742c8182c44e1$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $79c742c8182c44e1$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $79c742c8182c44e1$var$isCloning = false;
function $79c742c8182c44e1$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$79c742c8182c44e1$var$isCloning ? fallback(...args) : callback(...args);
}
function $79c742c8182c44e1$var$onlyDuringClone(callback) {
    return (...args)=>$79c742c8182c44e1$var$isCloning && callback(...args);
}
var $79c742c8182c44e1$var$interceptors = [];
function $79c742c8182c44e1$var$interceptClone(callback) {
    $79c742c8182c44e1$var$interceptors.push(callback);
}
function $79c742c8182c44e1$var$cloneNode(from, to) {
    $79c742c8182c44e1$var$interceptors.forEach((i)=>i(from, to));
    $79c742c8182c44e1$var$isCloning = true;
    $79c742c8182c44e1$var$dontRegisterReactiveSideEffects(()=>{
        $79c742c8182c44e1$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $79c742c8182c44e1$var$isCloning = false;
}
var $79c742c8182c44e1$var$isCloningLegacy = false;
function $79c742c8182c44e1$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $79c742c8182c44e1$var$isCloning = true;
    $79c742c8182c44e1$var$isCloningLegacy = true;
    $79c742c8182c44e1$var$dontRegisterReactiveSideEffects(()=>{
        $79c742c8182c44e1$var$cloneTree(newEl);
    });
    $79c742c8182c44e1$var$isCloning = false;
    $79c742c8182c44e1$var$isCloningLegacy = false;
}
function $79c742c8182c44e1$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $79c742c8182c44e1$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $79c742c8182c44e1$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $79c742c8182c44e1$var$initTree(el, shallowWalker);
}
function $79c742c8182c44e1$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $79c742c8182c44e1$var$effect;
    $79c742c8182c44e1$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $79c742c8182c44e1$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $79c742c8182c44e1$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $79c742c8182c44e1$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $79c742c8182c44e1$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $79c742c8182c44e1$var$camelCase(name) : name;
    switch(name){
        case "value":
            $79c742c8182c44e1$var$bindInputValue(el, value);
            break;
        case "style":
            $79c742c8182c44e1$var$bindStyles(el, value);
            break;
        case "class":
            $79c742c8182c44e1$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $79c742c8182c44e1$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $79c742c8182c44e1$var$bindAttribute(el, name, value);
            break;
    }
}
function $79c742c8182c44e1$var$bindInputValue(el, value) {
    if ($79c742c8182c44e1$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $79c742c8182c44e1$var$safeParseBoolean(el.value) === value;
            else el.checked = $79c742c8182c44e1$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($79c742c8182c44e1$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$79c742c8182c44e1$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $79c742c8182c44e1$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $79c742c8182c44e1$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $79c742c8182c44e1$var$setClasses(el, value);
}
function $79c742c8182c44e1$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $79c742c8182c44e1$var$setStyles(el, value);
}
function $79c742c8182c44e1$var$bindAttributeAndProperty(el, name, value) {
    $79c742c8182c44e1$var$bindAttribute(el, name, value);
    $79c742c8182c44e1$var$setPropertyIfChanged(el, name, value);
}
function $79c742c8182c44e1$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $79c742c8182c44e1$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($79c742c8182c44e1$var$isBooleanAttr(name)) value = name;
        $79c742c8182c44e1$var$setIfChanged(el, name, value);
    }
}
function $79c742c8182c44e1$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $79c742c8182c44e1$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $79c742c8182c44e1$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $79c742c8182c44e1$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $79c742c8182c44e1$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $79c742c8182c44e1$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $79c742c8182c44e1$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $79c742c8182c44e1$var$isBooleanAttr(attrName) {
    return $79c742c8182c44e1$var$booleanAttributes.has(attrName);
}
function $79c742c8182c44e1$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $79c742c8182c44e1$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $79c742c8182c44e1$var$getAttributeBinding(el, name, fallback);
}
function $79c742c8182c44e1$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $79c742c8182c44e1$var$dontAutoEvaluateFunctions(()=>{
            return $79c742c8182c44e1$var$evaluate(el, binding.expression);
        });
    }
    return $79c742c8182c44e1$var$getAttributeBinding(el, name, fallback);
}
function $79c742c8182c44e1$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($79c742c8182c44e1$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $79c742c8182c44e1$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $79c742c8182c44e1$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $79c742c8182c44e1$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $79c742c8182c44e1$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $79c742c8182c44e1$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $79c742c8182c44e1$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($79c742c8182c44e1$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($79c742c8182c44e1$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($79c742c8182c44e1$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $79c742c8182c44e1$var$release(reference);
    };
}
function $79c742c8182c44e1$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $79c742c8182c44e1$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($79c742c8182c44e1$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $79c742c8182c44e1$var$stores = {};
var $79c742c8182c44e1$var$isReactive = false;
function $79c742c8182c44e1$var$store(name, value) {
    if (!$79c742c8182c44e1$var$isReactive) {
        $79c742c8182c44e1$var$stores = $79c742c8182c44e1$var$reactive($79c742c8182c44e1$var$stores);
        $79c742c8182c44e1$var$isReactive = true;
    }
    if (value === void 0) return $79c742c8182c44e1$var$stores[name];
    $79c742c8182c44e1$var$stores[name] = value;
    $79c742c8182c44e1$var$initInterceptors($79c742c8182c44e1$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $79c742c8182c44e1$var$stores[name].init();
}
function $79c742c8182c44e1$var$getStores() {
    return $79c742c8182c44e1$var$stores;
}
// packages/alpinejs/src/binds.js
var $79c742c8182c44e1$var$binds = {};
function $79c742c8182c44e1$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $79c742c8182c44e1$var$applyBindingsObject(name, getBindings());
    else $79c742c8182c44e1$var$binds[name] = getBindings;
    return ()=>{};
}
function $79c742c8182c44e1$var$injectBindingProviders(obj) {
    Object.entries($79c742c8182c44e1$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $79c742c8182c44e1$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $79c742c8182c44e1$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $79c742c8182c44e1$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $79c742c8182c44e1$var$datas = {};
function $79c742c8182c44e1$var$data(name, callback) {
    $79c742c8182c44e1$var$datas[name] = callback;
}
function $79c742c8182c44e1$var$injectDataProviders(obj, context) {
    Object.entries($79c742c8182c44e1$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $79c742c8182c44e1$var$Alpine = {
    get reactive () {
        return $79c742c8182c44e1$var$reactive;
    },
    get release () {
        return $79c742c8182c44e1$var$release;
    },
    get effect () {
        return $79c742c8182c44e1$var$effect;
    },
    get raw () {
        return $79c742c8182c44e1$var$raw;
    },
    version: "3.14.3",
    flushAndStopDeferringMutations: $79c742c8182c44e1$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $79c742c8182c44e1$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $79c742c8182c44e1$var$disableEffectScheduling,
    startObservingMutations: $79c742c8182c44e1$var$startObservingMutations,
    stopObservingMutations: $79c742c8182c44e1$var$stopObservingMutations,
    setReactivityEngine: $79c742c8182c44e1$var$setReactivityEngine,
    onAttributeRemoved: $79c742c8182c44e1$var$onAttributeRemoved,
    onAttributesAdded: $79c742c8182c44e1$var$onAttributesAdded,
    closestDataStack: $79c742c8182c44e1$var$closestDataStack,
    skipDuringClone: $79c742c8182c44e1$var$skipDuringClone,
    onlyDuringClone: $79c742c8182c44e1$var$onlyDuringClone,
    addRootSelector: $79c742c8182c44e1$var$addRootSelector,
    addInitSelector: $79c742c8182c44e1$var$addInitSelector,
    interceptClone: $79c742c8182c44e1$var$interceptClone,
    addScopeToNode: $79c742c8182c44e1$var$addScopeToNode,
    deferMutations: $79c742c8182c44e1$var$deferMutations,
    mapAttributes: $79c742c8182c44e1$var$mapAttributes,
    evaluateLater: $79c742c8182c44e1$var$evaluateLater,
    interceptInit: $79c742c8182c44e1$var$interceptInit,
    setEvaluator: $79c742c8182c44e1$var$setEvaluator,
    mergeProxies: $79c742c8182c44e1$var$mergeProxies,
    extractProp: $79c742c8182c44e1$var$extractProp,
    findClosest: $79c742c8182c44e1$var$findClosest,
    onElRemoved: $79c742c8182c44e1$var$onElRemoved,
    closestRoot: $79c742c8182c44e1$var$closestRoot,
    destroyTree: $79c742c8182c44e1$var$destroyTree,
    interceptor: $79c742c8182c44e1$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $79c742c8182c44e1$var$transition,
    setStyles: // INTERNAL
    $79c742c8182c44e1$var$setStyles,
    mutateDom: // INTERNAL
    $79c742c8182c44e1$var$mutateDom,
    directive: $79c742c8182c44e1$var$directive,
    entangle: $79c742c8182c44e1$var$entangle,
    throttle: $79c742c8182c44e1$var$throttle,
    debounce: $79c742c8182c44e1$var$debounce,
    evaluate: $79c742c8182c44e1$var$evaluate,
    initTree: $79c742c8182c44e1$var$initTree,
    nextTick: $79c742c8182c44e1$var$nextTick,
    prefixed: $79c742c8182c44e1$var$prefix,
    prefix: $79c742c8182c44e1$var$setPrefix,
    plugin: $79c742c8182c44e1$var$plugin,
    magic: $79c742c8182c44e1$var$magic,
    store: $79c742c8182c44e1$var$store,
    start: $79c742c8182c44e1$var$start,
    clone: $79c742c8182c44e1$var$clone,
    cloneNode: // INTERNAL
    $79c742c8182c44e1$var$cloneNode,
    // INTERNAL
    bound: $79c742c8182c44e1$var$getBinding,
    $data: $79c742c8182c44e1$var$scope,
    watch: $79c742c8182c44e1$var$watch,
    walk: $79c742c8182c44e1$var$walk,
    data: $79c742c8182c44e1$var$data,
    bind: $79c742c8182c44e1$var$bind2
};
var $79c742c8182c44e1$var$alpine_default = $79c742c8182c44e1$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $79c742c8182c44e1$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $79c742c8182c44e1$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $79c742c8182c44e1$var$isBooleanAttr2 = /* @__PURE__ */ $79c742c8182c44e1$var$makeMap($79c742c8182c44e1$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $79c742c8182c44e1$var$EMPTY_OBJ = Object.freeze({});
var $79c742c8182c44e1$var$EMPTY_ARR = Object.freeze([]);
var $79c742c8182c44e1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $79c742c8182c44e1$var$hasOwn = (val, key)=>$79c742c8182c44e1$var$hasOwnProperty.call(val, key);
var $79c742c8182c44e1$var$isArray = Array.isArray;
var $79c742c8182c44e1$var$isMap = (val)=>$79c742c8182c44e1$var$toTypeString(val) === "[object Map]";
var $79c742c8182c44e1$var$isString = (val)=>typeof val === "string";
var $79c742c8182c44e1$var$isSymbol = (val)=>typeof val === "symbol";
var $79c742c8182c44e1$var$isObject = (val)=>val !== null && typeof val === "object";
var $79c742c8182c44e1$var$objectToString = Object.prototype.toString;
var $79c742c8182c44e1$var$toTypeString = (value)=>$79c742c8182c44e1$var$objectToString.call(value);
var $79c742c8182c44e1$var$toRawType = (value)=>{
    return $79c742c8182c44e1$var$toTypeString(value).slice(8, -1);
};
var $79c742c8182c44e1$var$isIntegerKey = (key)=>$79c742c8182c44e1$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $79c742c8182c44e1$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $79c742c8182c44e1$var$camelizeRE = /-(\w)/g;
var $79c742c8182c44e1$var$camelize = $79c742c8182c44e1$var$cacheStringFunction((str)=>{
    return str.replace($79c742c8182c44e1$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $79c742c8182c44e1$var$hyphenateRE = /\B([A-Z])/g;
var $79c742c8182c44e1$var$hyphenate = $79c742c8182c44e1$var$cacheStringFunction((str)=>str.replace($79c742c8182c44e1$var$hyphenateRE, "-$1").toLowerCase());
var $79c742c8182c44e1$var$capitalize = $79c742c8182c44e1$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $79c742c8182c44e1$var$toHandlerKey = $79c742c8182c44e1$var$cacheStringFunction((str)=>str ? `on${$79c742c8182c44e1$var$capitalize(str)}` : ``);
var $79c742c8182c44e1$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $79c742c8182c44e1$var$targetMap = /* @__PURE__ */ new WeakMap();
var $79c742c8182c44e1$var$effectStack = [];
var $79c742c8182c44e1$var$activeEffect;
var $79c742c8182c44e1$var$ITERATE_KEY = Symbol("iterate");
var $79c742c8182c44e1$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $79c742c8182c44e1$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $79c742c8182c44e1$var$effect2(fn, options = $79c742c8182c44e1$var$EMPTY_OBJ) {
    if ($79c742c8182c44e1$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $79c742c8182c44e1$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $79c742c8182c44e1$var$stop(effect3) {
    if (effect3.active) {
        $79c742c8182c44e1$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $79c742c8182c44e1$var$uid = 0;
function $79c742c8182c44e1$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$79c742c8182c44e1$var$effectStack.includes(effect3)) {
            $79c742c8182c44e1$var$cleanup(effect3);
            try {
                $79c742c8182c44e1$var$enableTracking();
                $79c742c8182c44e1$var$effectStack.push(effect3);
                $79c742c8182c44e1$var$activeEffect = effect3;
                return fn();
            } finally{
                $79c742c8182c44e1$var$effectStack.pop();
                $79c742c8182c44e1$var$resetTracking();
                $79c742c8182c44e1$var$activeEffect = $79c742c8182c44e1$var$effectStack[$79c742c8182c44e1$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $79c742c8182c44e1$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $79c742c8182c44e1$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $79c742c8182c44e1$var$shouldTrack = true;
var $79c742c8182c44e1$var$trackStack = [];
function $79c742c8182c44e1$var$pauseTracking() {
    $79c742c8182c44e1$var$trackStack.push($79c742c8182c44e1$var$shouldTrack);
    $79c742c8182c44e1$var$shouldTrack = false;
}
function $79c742c8182c44e1$var$enableTracking() {
    $79c742c8182c44e1$var$trackStack.push($79c742c8182c44e1$var$shouldTrack);
    $79c742c8182c44e1$var$shouldTrack = true;
}
function $79c742c8182c44e1$var$resetTracking() {
    const last = $79c742c8182c44e1$var$trackStack.pop();
    $79c742c8182c44e1$var$shouldTrack = last === void 0 ? true : last;
}
function $79c742c8182c44e1$var$track(target, type, key) {
    if (!$79c742c8182c44e1$var$shouldTrack || $79c742c8182c44e1$var$activeEffect === void 0) return;
    let depsMap = $79c742c8182c44e1$var$targetMap.get(target);
    if (!depsMap) $79c742c8182c44e1$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($79c742c8182c44e1$var$activeEffect)) {
        dep.add($79c742c8182c44e1$var$activeEffect);
        $79c742c8182c44e1$var$activeEffect.deps.push(dep);
        if ($79c742c8182c44e1$var$activeEffect.options.onTrack) $79c742c8182c44e1$var$activeEffect.options.onTrack({
            effect: $79c742c8182c44e1$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $79c742c8182c44e1$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $79c742c8182c44e1$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $79c742c8182c44e1$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $79c742c8182c44e1$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$79c742c8182c44e1$var$isArray(target)) {
                    add2(depsMap.get($79c742c8182c44e1$var$ITERATE_KEY));
                    if ($79c742c8182c44e1$var$isMap(target)) add2(depsMap.get($79c742c8182c44e1$var$MAP_KEY_ITERATE_KEY));
                } else if ($79c742c8182c44e1$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$79c742c8182c44e1$var$isArray(target)) {
                    add2(depsMap.get($79c742c8182c44e1$var$ITERATE_KEY));
                    if ($79c742c8182c44e1$var$isMap(target)) add2(depsMap.get($79c742c8182c44e1$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($79c742c8182c44e1$var$isMap(target)) add2(depsMap.get($79c742c8182c44e1$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $79c742c8182c44e1$var$isNonTrackableKeys = /* @__PURE__ */ $79c742c8182c44e1$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $79c742c8182c44e1$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($79c742c8182c44e1$var$isSymbol));
var $79c742c8182c44e1$var$get2 = /* @__PURE__ */ $79c742c8182c44e1$var$createGetter();
var $79c742c8182c44e1$var$readonlyGet = /* @__PURE__ */ $79c742c8182c44e1$var$createGetter(true);
var $79c742c8182c44e1$var$arrayInstrumentations = /* @__PURE__ */ $79c742c8182c44e1$var$createArrayInstrumentations();
function $79c742c8182c44e1$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $79c742c8182c44e1$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$79c742c8182c44e1$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($79c742c8182c44e1$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $79c742c8182c44e1$var$pauseTracking();
            const res = $79c742c8182c44e1$var$toRaw(this)[key].apply(this, args);
            $79c742c8182c44e1$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $79c742c8182c44e1$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $79c742c8182c44e1$var$shallowReadonlyMap : $79c742c8182c44e1$var$readonlyMap : shallow ? $79c742c8182c44e1$var$shallowReactiveMap : $79c742c8182c44e1$var$reactiveMap).get(target)) return target;
        const targetIsArray = $79c742c8182c44e1$var$isArray(target);
        if (!isReadonly && targetIsArray && $79c742c8182c44e1$var$hasOwn($79c742c8182c44e1$var$arrayInstrumentations, key)) return Reflect.get($79c742c8182c44e1$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($79c742c8182c44e1$var$isSymbol(key) ? $79c742c8182c44e1$var$builtInSymbols.has(key) : $79c742c8182c44e1$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $79c742c8182c44e1$var$track(target, "get", key);
        if (shallow) return res;
        if ($79c742c8182c44e1$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$79c742c8182c44e1$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($79c742c8182c44e1$var$isObject(res)) return isReadonly ? $79c742c8182c44e1$var$readonly(res) : $79c742c8182c44e1$var$reactive2(res);
        return res;
    };
}
var $79c742c8182c44e1$var$set2 = /* @__PURE__ */ $79c742c8182c44e1$var$createSetter();
function $79c742c8182c44e1$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $79c742c8182c44e1$var$toRaw(value);
            oldValue = $79c742c8182c44e1$var$toRaw(oldValue);
            if (!$79c742c8182c44e1$var$isArray(target) && $79c742c8182c44e1$var$isRef(oldValue) && !$79c742c8182c44e1$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $79c742c8182c44e1$var$isArray(target) && $79c742c8182c44e1$var$isIntegerKey(key) ? Number(key) < target.length : $79c742c8182c44e1$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $79c742c8182c44e1$var$toRaw(receiver)) {
            if (!hadKey) $79c742c8182c44e1$var$trigger(target, "add", key, value);
            else if ($79c742c8182c44e1$var$hasChanged(value, oldValue)) $79c742c8182c44e1$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $79c742c8182c44e1$var$deleteProperty(target, key) {
    const hadKey = $79c742c8182c44e1$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $79c742c8182c44e1$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $79c742c8182c44e1$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$79c742c8182c44e1$var$isSymbol(key) || !$79c742c8182c44e1$var$builtInSymbols.has(key)) $79c742c8182c44e1$var$track(target, "has", key);
    return result;
}
function $79c742c8182c44e1$var$ownKeys(target) {
    $79c742c8182c44e1$var$track(target, "iterate", $79c742c8182c44e1$var$isArray(target) ? "length" : $79c742c8182c44e1$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $79c742c8182c44e1$var$mutableHandlers = {
    get: $79c742c8182c44e1$var$get2,
    set: $79c742c8182c44e1$var$set2,
    deleteProperty: $79c742c8182c44e1$var$deleteProperty,
    has: $79c742c8182c44e1$var$has,
    ownKeys: $79c742c8182c44e1$var$ownKeys
};
var $79c742c8182c44e1$var$readonlyHandlers = {
    get: $79c742c8182c44e1$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $79c742c8182c44e1$var$toReactive = (value)=>$79c742c8182c44e1$var$isObject(value) ? $79c742c8182c44e1$var$reactive2(value) : value;
var $79c742c8182c44e1$var$toReadonly = (value)=>$79c742c8182c44e1$var$isObject(value) ? $79c742c8182c44e1$var$readonly(value) : value;
var $79c742c8182c44e1$var$toShallow = (value)=>value;
var $79c742c8182c44e1$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $79c742c8182c44e1$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $79c742c8182c44e1$var$toRaw(target);
    const rawKey = $79c742c8182c44e1$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "get", key);
    !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $79c742c8182c44e1$var$getProto(rawTarget);
    const wrap = isShallow ? $79c742c8182c44e1$var$toShallow : isReadonly ? $79c742c8182c44e1$var$toReadonly : $79c742c8182c44e1$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $79c742c8182c44e1$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $79c742c8182c44e1$var$toRaw(target);
    const rawKey = $79c742c8182c44e1$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "has", key);
    !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $79c742c8182c44e1$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $79c742c8182c44e1$var$track($79c742c8182c44e1$var$toRaw(target), "iterate", $79c742c8182c44e1$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $79c742c8182c44e1$var$add(value) {
    value = $79c742c8182c44e1$var$toRaw(value);
    const target = $79c742c8182c44e1$var$toRaw(this);
    const proto = $79c742c8182c44e1$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $79c742c8182c44e1$var$trigger(target, "add", value, value);
    }
    return this;
}
function $79c742c8182c44e1$var$set$1(key, value) {
    value = $79c742c8182c44e1$var$toRaw(value);
    const target = $79c742c8182c44e1$var$toRaw(this);
    const { has: has2, get: get3 } = $79c742c8182c44e1$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $79c742c8182c44e1$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $79c742c8182c44e1$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $79c742c8182c44e1$var$trigger(target, "add", key, value);
    else if ($79c742c8182c44e1$var$hasChanged(value, oldValue)) $79c742c8182c44e1$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $79c742c8182c44e1$var$deleteEntry(key) {
    const target = $79c742c8182c44e1$var$toRaw(this);
    const { has: has2, get: get3 } = $79c742c8182c44e1$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $79c742c8182c44e1$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $79c742c8182c44e1$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $79c742c8182c44e1$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $79c742c8182c44e1$var$clear() {
    const target = $79c742c8182c44e1$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $79c742c8182c44e1$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $79c742c8182c44e1$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $79c742c8182c44e1$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $79c742c8182c44e1$var$toRaw(target);
        const wrap = isShallow ? $79c742c8182c44e1$var$toShallow : isReadonly ? $79c742c8182c44e1$var$toReadonly : $79c742c8182c44e1$var$toReactive;
        !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "iterate", $79c742c8182c44e1$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $79c742c8182c44e1$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $79c742c8182c44e1$var$toRaw(target);
        const targetIsMap = $79c742c8182c44e1$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $79c742c8182c44e1$var$toShallow : isReadonly ? $79c742c8182c44e1$var$toReadonly : $79c742c8182c44e1$var$toReactive;
        !isReadonly && $79c742c8182c44e1$var$track(rawTarget, "iterate", isKeyOnly ? $79c742c8182c44e1$var$MAP_KEY_ITERATE_KEY : $79c742c8182c44e1$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $79c742c8182c44e1$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$79c742c8182c44e1$var$capitalize(type)} operation ${key}failed: target is readonly.`, $79c742c8182c44e1$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $79c742c8182c44e1$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $79c742c8182c44e1$var$get$1(this, key);
        },
        get size () {
            return $79c742c8182c44e1$var$size(this);
        },
        has: $79c742c8182c44e1$var$has$1,
        add: $79c742c8182c44e1$var$add,
        set: $79c742c8182c44e1$var$set$1,
        delete: $79c742c8182c44e1$var$deleteEntry,
        clear: $79c742c8182c44e1$var$clear,
        forEach: $79c742c8182c44e1$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $79c742c8182c44e1$var$get$1(this, key, false, true);
        },
        get size () {
            return $79c742c8182c44e1$var$size(this);
        },
        has: $79c742c8182c44e1$var$has$1,
        add: $79c742c8182c44e1$var$add,
        set: $79c742c8182c44e1$var$set$1,
        delete: $79c742c8182c44e1$var$deleteEntry,
        clear: $79c742c8182c44e1$var$clear,
        forEach: $79c742c8182c44e1$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $79c742c8182c44e1$var$get$1(this, key, true);
        },
        get size () {
            return $79c742c8182c44e1$var$size(this, true);
        },
        has (key) {
            return $79c742c8182c44e1$var$has$1.call(this, key, true);
        },
        add: $79c742c8182c44e1$var$createReadonlyMethod("add"),
        set: $79c742c8182c44e1$var$createReadonlyMethod("set"),
        delete: $79c742c8182c44e1$var$createReadonlyMethod("delete"),
        clear: $79c742c8182c44e1$var$createReadonlyMethod("clear"),
        forEach: $79c742c8182c44e1$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $79c742c8182c44e1$var$get$1(this, key, true, true);
        },
        get size () {
            return $79c742c8182c44e1$var$size(this, true);
        },
        has (key) {
            return $79c742c8182c44e1$var$has$1.call(this, key, true);
        },
        add: $79c742c8182c44e1$var$createReadonlyMethod("add"),
        set: $79c742c8182c44e1$var$createReadonlyMethod("set"),
        delete: $79c742c8182c44e1$var$createReadonlyMethod("delete"),
        clear: $79c742c8182c44e1$var$createReadonlyMethod("clear"),
        forEach: $79c742c8182c44e1$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $79c742c8182c44e1$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $79c742c8182c44e1$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $79c742c8182c44e1$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $79c742c8182c44e1$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$79c742c8182c44e1$var$mutableInstrumentations, $79c742c8182c44e1$var$readonlyInstrumentations, $79c742c8182c44e1$var$shallowInstrumentations, $79c742c8182c44e1$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $79c742c8182c44e1$var$createInstrumentations();
function $79c742c8182c44e1$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $79c742c8182c44e1$var$shallowReadonlyInstrumentations : $79c742c8182c44e1$var$shallowInstrumentations : isReadonly ? $79c742c8182c44e1$var$readonlyInstrumentations : $79c742c8182c44e1$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($79c742c8182c44e1$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $79c742c8182c44e1$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $79c742c8182c44e1$var$createInstrumentationGetter(false, false)
};
var $79c742c8182c44e1$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $79c742c8182c44e1$var$createInstrumentationGetter(true, false)
};
function $79c742c8182c44e1$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $79c742c8182c44e1$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $79c742c8182c44e1$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $79c742c8182c44e1$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $79c742c8182c44e1$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $79c742c8182c44e1$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $79c742c8182c44e1$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $79c742c8182c44e1$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $79c742c8182c44e1$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $79c742c8182c44e1$var$targetTypeMap($79c742c8182c44e1$var$toRawType(value));
}
function $79c742c8182c44e1$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $79c742c8182c44e1$var$createReactiveObject(target, false, $79c742c8182c44e1$var$mutableHandlers, $79c742c8182c44e1$var$mutableCollectionHandlers, $79c742c8182c44e1$var$reactiveMap);
}
function $79c742c8182c44e1$var$readonly(target) {
    return $79c742c8182c44e1$var$createReactiveObject(target, true, $79c742c8182c44e1$var$readonlyHandlers, $79c742c8182c44e1$var$readonlyCollectionHandlers, $79c742c8182c44e1$var$readonlyMap);
}
function $79c742c8182c44e1$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$79c742c8182c44e1$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $79c742c8182c44e1$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $79c742c8182c44e1$var$toRaw(observed) {
    return observed && $79c742c8182c44e1$var$toRaw(observed["__v_raw"]) || observed;
}
function $79c742c8182c44e1$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$79c742c8182c44e1$var$magic("nextTick", ()=>$79c742c8182c44e1$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$79c742c8182c44e1$var$magic("dispatch", (el)=>$79c742c8182c44e1$var$dispatch.bind($79c742c8182c44e1$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$79c742c8182c44e1$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $79c742c8182c44e1$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$79c742c8182c44e1$var$magic("store", $79c742c8182c44e1$var$getStores);
// packages/alpinejs/src/magics/$data.js
$79c742c8182c44e1$var$magic("data", (el)=>$79c742c8182c44e1$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$79c742c8182c44e1$var$magic("root", (el)=>$79c742c8182c44e1$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$79c742c8182c44e1$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $79c742c8182c44e1$var$mergeProxies($79c742c8182c44e1$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $79c742c8182c44e1$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $79c742c8182c44e1$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $79c742c8182c44e1$var$globalIdMemo = {};
function $79c742c8182c44e1$var$findAndIncrementId(name) {
    if (!$79c742c8182c44e1$var$globalIdMemo[name]) $79c742c8182c44e1$var$globalIdMemo[name] = 0;
    return ++$79c742c8182c44e1$var$globalIdMemo[name];
}
function $79c742c8182c44e1$var$closestIdRoot(el, name) {
    return $79c742c8182c44e1$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $79c742c8182c44e1$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $79c742c8182c44e1$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$79c742c8182c44e1$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $79c742c8182c44e1$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $79c742c8182c44e1$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $79c742c8182c44e1$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$79c742c8182c44e1$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $79c742c8182c44e1$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$79c742c8182c44e1$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$79c742c8182c44e1$var$warnMissingPluginMagic("Focus", "focus", "focus");
$79c742c8182c44e1$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $79c742c8182c44e1$var$warnMissingPluginMagic(name, magicName, slug) {
    $79c742c8182c44e1$var$magic(magicName, (el)=>$79c742c8182c44e1$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$79c742c8182c44e1$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $79c742c8182c44e1$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$79c742c8182c44e1$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $79c742c8182c44e1$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $79c742c8182c44e1$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $79c742c8182c44e1$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $79c742c8182c44e1$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $79c742c8182c44e1$var$skipDuringClone(()=>{
            $79c742c8182c44e1$var$initTree(clone2);
            clone2._x_ignore = true;
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $79c742c8182c44e1$var$getTarget(expression);
        $79c742c8182c44e1$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$79c742c8182c44e1$var$mutateDom(()=>{
            clone2.remove();
            $79c742c8182c44e1$var$destroyTree(clone2);
        }));
});
var $79c742c8182c44e1$var$teleportContainerDuringClone = document.createElement("div");
function $79c742c8182c44e1$var$getTarget(expression) {
    let target = $79c742c8182c44e1$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $79c742c8182c44e1$var$teleportContainerDuringClone;
    })();
    if (!target) $79c742c8182c44e1$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $79c742c8182c44e1$var$handler = ()=>{};
$79c742c8182c44e1$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$79c742c8182c44e1$var$directive("ignore", $79c742c8182c44e1$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$79c742c8182c44e1$var$directive("effect", $79c742c8182c44e1$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($79c742c8182c44e1$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $79c742c8182c44e1$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $79c742c8182c44e1$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $79c742c8182c44e1$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $79c742c8182c44e1$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $79c742c8182c44e1$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $79c742c8182c44e1$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $79c742c8182c44e1$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($79c742c8182c44e1$var$isKeyEvent(event) || $79c742c8182c44e1$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($79c742c8182c44e1$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $79c742c8182c44e1$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $79c742c8182c44e1$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $79c742c8182c44e1$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $79c742c8182c44e1$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $79c742c8182c44e1$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $79c742c8182c44e1$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $79c742c8182c44e1$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $79c742c8182c44e1$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $79c742c8182c44e1$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $79c742c8182c44e1$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($79c742c8182c44e1$var$isClickEvent(e.type)) return false;
            if ($79c742c8182c44e1$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $79c742c8182c44e1$var$keyToModifiers(key) {
    if (!key) return [];
    key = $79c742c8182c44e1$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$79c742c8182c44e1$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $79c742c8182c44e1$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $79c742c8182c44e1$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $79c742c8182c44e1$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $79c742c8182c44e1$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($79c742c8182c44e1$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $79c742c8182c44e1$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $79c742c8182c44e1$var$isCloning ? ()=>{} : $79c742c8182c44e1$var$on(el, event, modifiers, (e)=>{
        setValue($79c742c8182c44e1$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $79c742c8182c44e1$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($79c742c8182c44e1$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $79c742c8182c44e1$var$on(el.form, "reset", [], (e)=>{
            $79c742c8182c44e1$var$nextTick(()=>el._x_model && el._x_model.set($79c742c8182c44e1$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $79c742c8182c44e1$var$mutateDom(()=>$79c742c8182c44e1$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $79c742c8182c44e1$var$getInputValue(el, modifiers, event, currentValue) {
    return $79c742c8182c44e1$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($79c742c8182c44e1$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $79c742c8182c44e1$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $79c742c8182c44e1$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$79c742c8182c44e1$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $79c742c8182c44e1$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $79c742c8182c44e1$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($79c742c8182c44e1$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $79c742c8182c44e1$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $79c742c8182c44e1$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $79c742c8182c44e1$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $79c742c8182c44e1$var$isNumeric2(number) ? number : rawValue;
}
function $79c742c8182c44e1$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $79c742c8182c44e1$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $79c742c8182c44e1$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$79c742c8182c44e1$var$directive("cloak", (el)=>queueMicrotask(()=>$79c742c8182c44e1$var$mutateDom(()=>el.removeAttribute($79c742c8182c44e1$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$79c742c8182c44e1$var$addInitSelector(()=>`[${$79c742c8182c44e1$var$prefix("init")}]`);
$79c742c8182c44e1$var$directive("init", $79c742c8182c44e1$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$79c742c8182c44e1$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $79c742c8182c44e1$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$79c742c8182c44e1$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $79c742c8182c44e1$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $79c742c8182c44e1$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$79c742c8182c44e1$var$mapAttributes($79c742c8182c44e1$var$startingWith(":", $79c742c8182c44e1$var$into($79c742c8182c44e1$var$prefix("bind:"))));
var $79c742c8182c44e1$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $79c742c8182c44e1$var$injectBindingProviders(bindingProviders);
        let getBindings = $79c742c8182c44e1$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $79c742c8182c44e1$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $79c742c8182c44e1$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $79c742c8182c44e1$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $79c742c8182c44e1$var$mutateDom(()=>$79c742c8182c44e1$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$79c742c8182c44e1$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$79c742c8182c44e1$var$directive("bind", $79c742c8182c44e1$var$handler2);
function $79c742c8182c44e1$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$79c742c8182c44e1$var$addRootSelector(()=>`[${$79c742c8182c44e1$var$prefix("data")}]`);
$79c742c8182c44e1$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($79c742c8182c44e1$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $79c742c8182c44e1$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $79c742c8182c44e1$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $79c742c8182c44e1$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $79c742c8182c44e1$var$injectMagics(data2, el);
    let reactiveData = $79c742c8182c44e1$var$reactive(data2);
    $79c742c8182c44e1$var$initInterceptors(reactiveData);
    let undo = $79c742c8182c44e1$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $79c742c8182c44e1$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $79c742c8182c44e1$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$79c742c8182c44e1$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $79c742c8182c44e1$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$79c742c8182c44e1$var$isCloning) return false;
    if ($79c742c8182c44e1$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$79c742c8182c44e1$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $79c742c8182c44e1$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $79c742c8182c44e1$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $79c742c8182c44e1$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $79c742c8182c44e1$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$79c742c8182c44e1$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $79c742c8182c44e1$var$parseForExpression(expression);
    let evaluateItems = $79c742c8182c44e1$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $79c742c8182c44e1$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$79c742c8182c44e1$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$79c742c8182c44e1$var$mutateDom(()=>{
                $79c742c8182c44e1$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $79c742c8182c44e1$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($79c742c8182c44e1$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $79c742c8182c44e1$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $79c742c8182c44e1$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $79c742c8182c44e1$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $79c742c8182c44e1$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $79c742c8182c44e1$var$mutateDom(()=>{
                $79c742c8182c44e1$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $79c742c8182c44e1$var$mutateDom(()=>{
                if (!elForSpot) $79c742c8182c44e1$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $79c742c8182c44e1$var$reactive(scope2);
            $79c742c8182c44e1$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $79c742c8182c44e1$var$mutateDom(()=>{
                lastEl.after(clone2);
                $79c742c8182c44e1$var$skipDuringClone(()=>$79c742c8182c44e1$var$initTree(clone2))();
            });
            if (typeof key === "object") $79c742c8182c44e1$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $79c742c8182c44e1$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $79c742c8182c44e1$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $79c742c8182c44e1$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $79c742c8182c44e1$var$handler3() {}
$79c742c8182c44e1$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $79c742c8182c44e1$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$79c742c8182c44e1$var$directive("ref", $79c742c8182c44e1$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$79c742c8182c44e1$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $79c742c8182c44e1$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $79c742c8182c44e1$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $79c742c8182c44e1$var$addScopeToNode(clone2, {}, el);
        $79c742c8182c44e1$var$mutateDom(()=>{
            el.after(clone2);
            $79c742c8182c44e1$var$skipDuringClone(()=>$79c742c8182c44e1$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $79c742c8182c44e1$var$mutateDom(()=>{
                $79c742c8182c44e1$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$79c742c8182c44e1$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$79c742c8182c44e1$var$setIdRoot(el, name));
});
$79c742c8182c44e1$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$79c742c8182c44e1$var$mapAttributes($79c742c8182c44e1$var$startingWith("@", $79c742c8182c44e1$var$into($79c742c8182c44e1$var$prefix("on:"))));
$79c742c8182c44e1$var$directive("on", $79c742c8182c44e1$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $79c742c8182c44e1$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $79c742c8182c44e1$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$79c742c8182c44e1$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$79c742c8182c44e1$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$79c742c8182c44e1$var$warnMissingPluginDirective("Focus", "trap", "focus");
$79c742c8182c44e1$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $79c742c8182c44e1$var$warnMissingPluginDirective(name, directiveName, slug) {
    $79c742c8182c44e1$var$directive(directiveName, (el)=>$79c742c8182c44e1$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$79c742c8182c44e1$var$alpine_default.setEvaluator($79c742c8182c44e1$var$normalEvaluator);
$79c742c8182c44e1$var$alpine_default.setReactivityEngine({
    reactive: $79c742c8182c44e1$var$reactive2,
    effect: $79c742c8182c44e1$var$effect2,
    release: $79c742c8182c44e1$var$stop,
    raw: $79c742c8182c44e1$var$toRaw
});
var $79c742c8182c44e1$export$b7ee041e4ad2afec = $79c742c8182c44e1$var$alpine_default;
// packages/alpinejs/builds/module.js
var $79c742c8182c44e1$export$2e2bcd8739ae039 = $79c742c8182c44e1$export$b7ee041e4ad2afec;


// packages/collapse/src/index.js
function $d1d4bac008700b8f$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $d1d4bac008700b8f$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $d1d4bac008700b8f$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $d1d4bac008700b8f$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $d1d4bac008700b8f$export$2e2bcd8739ae039 = $d1d4bac008700b8f$export$ec45920981e0ca9b;


/* eslint-disable prettier/prettier */ var $30c3cbfd128fd96c$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $30c3cbfd128fd96c$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $2bf5232d6f815586$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $2bf5232d6f815586$export$2e2bcd8739ae039 = $2bf5232d6f815586$export$33e6c23ebe2ee669;


var $14ad6f40cde1c893$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $14ad6f40cde1c893$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $14ad6f40cde1c893$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $14ad6f40cde1c893$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $03eba94f2a35a45d$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $03eba94f2a35a45d$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $03eba94f2a35a45d$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $03eba94f2a35a45d$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $03eba94f2a35a45d$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $03eba94f2a35a45d$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $03eba94f2a35a45d$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $03eba94f2a35a45d$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $03eba94f2a35a45d$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $03eba94f2a35a45d$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $03eba94f2a35a45d$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $326a1e2fa8887a41$var$doNothing = function() {
    return undefined;
};
var $326a1e2fa8887a41$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $326a1e2fa8887a41$export$9490b78b888a863f = {
    D: $326a1e2fa8887a41$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $326a1e2fa8887a41$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $326a1e2fa8887a41$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $326a1e2fa8887a41$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $326a1e2fa8887a41$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$326a1e2fa8887a41$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $326a1e2fa8887a41$export$27a2dd9af757e89c($326a1e2fa8887a41$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)($326a1e2fa8887a41$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $326a1e2fa8887a41$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $67a8e29474d225e1$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $2bf5232d6f815586$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $326a1e2fa8887a41$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $326a1e2fa8887a41$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $67a8e29474d225e1$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $2bf5232d6f815586$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $326a1e2fa8887a41$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $67a8e29474d225e1$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $67a8e29474d225e1$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $67a8e29474d225e1$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $67a8e29474d225e1$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $67a8e29474d225e1$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $67a8e29474d225e1$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $67a8e29474d225e1$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $dd2925d3f317f2a9$var$__assign = undefined && undefined.__assign || function() {
    $dd2925d3f317f2a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd2925d3f317f2a9$var$__assign.apply(this, arguments);
};
var $dd2925d3f317f2a9$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $dd2925d3f317f2a9$var$DEBOUNCED_CHANGE_MS = 300;
function $dd2925d3f317f2a9$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e)), $dd2925d3f317f2a9$var$flatpickr.defaultConfig),
        l10n: (0, $2bf5232d6f815586$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $67a8e29474d225e1$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $67a8e29474d225e1$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $67a8e29474d225e1$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $67a8e29474d225e1$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $67a8e29474d225e1$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $67a8e29474d225e1$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $67a8e29474d225e1$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $67a8e29474d225e1$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $67a8e29474d225e1$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $14ad6f40cde1c893$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $14ad6f40cde1c893$export$61fc7d43ac8f84b0)(triggerChange, $dd2925d3f317f2a9$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $67a8e29474d225e1$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $67a8e29474d225e1$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $67a8e29474d225e1$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $03eba94f2a35a45d$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $03eba94f2a35a45d$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $326a1e2fa8887a41$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $03eba94f2a35a45d$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $03eba94f2a35a45d$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $67a8e29474d225e1$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $03eba94f2a35a45d$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $03eba94f2a35a45d$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $03eba94f2a35a45d$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $03eba94f2a35a45d$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $dd2925d3f317f2a9$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $dd2925d3f317f2a9$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $67a8e29474d225e1$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $67a8e29474d225e1$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $67a8e29474d225e1$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $67a8e29474d225e1$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $67a8e29474d225e1$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $dd2925d3f317f2a9$var$flatpickr.defaultConfig.dateFormat || (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $dd2925d3f317f2a9$var$flatpickr.defaultConfig.altFormat || (0, $30c3cbfd128fd96c$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $30c3cbfd128fd96c$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $14ad6f40cde1c893$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $30c3cbfd128fd96c$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $14ad6f40cde1c893$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $dd2925d3f317f2a9$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, $dd2925d3f317f2a9$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $dd2925d3f317f2a9$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $326a1e2fa8887a41$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $dd2925d3f317f2a9$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $67a8e29474d225e1$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $67a8e29474d225e1$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $03eba94f2a35a45d$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $03eba94f2a35a45d$export$25245567f53f158f)((0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $67a8e29474d225e1$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $30c3cbfd128fd96c$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $14ad6f40cde1c893$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $03eba94f2a35a45d$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $67a8e29474d225e1$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $67a8e29474d225e1$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $67a8e29474d225e1$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $326a1e2fa8887a41$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $03eba94f2a35a45d$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(isHourElem) && (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $14ad6f40cde1c893$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $14ad6f40cde1c893$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $dd2925d3f317f2a9$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $dd2925d3f317f2a9$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $dd2925d3f317f2a9$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $dd2925d3f317f2a9$var$_flatpickr([
            this
        ], config);
    };
}
var $dd2925d3f317f2a9$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $dd2925d3f317f2a9$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $dd2925d3f317f2a9$var$_flatpickr([
        selector
    ], config);
    else return $dd2925d3f317f2a9$var$_flatpickr(selector, config);
};
$dd2925d3f317f2a9$var$flatpickr.defaultConfig = {};
$dd2925d3f317f2a9$var$flatpickr.l10ns = {
    en: $dd2925d3f317f2a9$var$__assign({}, (0, $2bf5232d6f815586$export$2e2bcd8739ae039)),
    default: $dd2925d3f317f2a9$var$__assign({}, (0, $2bf5232d6f815586$export$2e2bcd8739ae039))
};
$dd2925d3f317f2a9$var$flatpickr.localize = function(l10n) {
    $dd2925d3f317f2a9$var$flatpickr.l10ns.default = $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, $dd2925d3f317f2a9$var$flatpickr.l10ns.default), l10n);
};
$dd2925d3f317f2a9$var$flatpickr.setDefaults = function(config) {
    $dd2925d3f317f2a9$var$flatpickr.defaultConfig = $dd2925d3f317f2a9$var$__assign($dd2925d3f317f2a9$var$__assign({}, $dd2925d3f317f2a9$var$flatpickr.defaultConfig), config);
};
$dd2925d3f317f2a9$var$flatpickr.parseDate = (0, $67a8e29474d225e1$export$cfa2ef2687faeda2)({});
$dd2925d3f317f2a9$var$flatpickr.formatDate = (0, $67a8e29474d225e1$export$ff1a0b75284ac636)({});
$dd2925d3f317f2a9$var$flatpickr.compareDates = (0, $67a8e29474d225e1$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $dd2925d3f317f2a9$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $dd2925d3f317f2a9$var$flatpickr;
var $dd2925d3f317f2a9$export$2e2bcd8739ae039 = $dd2925d3f317f2a9$var$flatpickr;


var $44d39541db003f03$exports = {};
(function(global, factory) {
    factory($44d39541db003f03$exports);
})($44d39541db003f03$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Swedish = {
        firstDayOfWeek: 1,
        weekAbbreviation: "v",
        weekdays: {
            shorthand: [
                "s\xf6n",
                "m\xe5n",
                "tis",
                "ons",
                "tor",
                "fre",
                "l\xf6r"
            ],
            longhand: [
                "s\xf6ndag",
                "m\xe5ndag",
                "tisdag",
                "onsdag",
                "torsdag",
                "fredag",
                "l\xf6rdag"
            ]
        },
        months: {
            shorthand: [
                "jan",
                "feb",
                "mar",
                "apr",
                "maj",
                "jun",
                "jul",
                "aug",
                "sep",
                "okt",
                "nov",
                "dec"
            ],
            longhand: [
                "januari",
                "februari",
                "mars",
                "april",
                "maj",
                "juni",
                "juli",
                "augusti",
                "september",
                "oktober",
                "november",
                "december"
            ]
        },
        rangeSeparator: " till ",
        time_24hr: true,
        ordinal: function() {
            return ".";
        }
    };
    fp.l10ns.sv = Swedish;
    var sv = fp.l10ns;
    exports1.Swedish = Swedish;
    exports1.default = sv;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


const $6dad9254e76b1584$var$calendarEl = document.querySelector('#calendar');
const $6dad9254e76b1584$var$calendarItems = document.querySelectorAll('.calendar-block--item');
const $6dad9254e76b1584$var$eventDates = [];
const $6dad9254e76b1584$var$calendarInfo = document.querySelector('#calendar-info-text');
const $6dad9254e76b1584$var$calendarEventSection = document.querySelector('#calendar-event-text');
const $6dad9254e76b1584$var$closeEventSection = document.querySelector('.calendar-block--text--close');
const $6dad9254e76b1584$var$calendarBlurbs = document.querySelectorAll('.calendar-burb--card');
$6dad9254e76b1584$var$calendarItems.forEach((item)=>{
    if (item.hasAttribute('data-date') && item.getAttribute('data-date') != null) $6dad9254e76b1584$var$eventDates.push(item.getAttribute('data-date'));
});
const $6dad9254e76b1584$var$hideInfoItem = ()=>{
    $6dad9254e76b1584$var$calendarInfo.style.display = 'none';
};
const $6dad9254e76b1584$var$showInfoItem = ()=>{
    $6dad9254e76b1584$var$calendarInfo.style.display = 'block';
    $6dad9254e76b1584$var$calendarEventSection.style.display = 'none';
};
const $6dad9254e76b1584$var$showEventSection = ()=>{
    $6dad9254e76b1584$var$calendarEventSection.style.display = 'block';
};
const $6dad9254e76b1584$var$hideAllItems = ()=>{
    $6dad9254e76b1584$var$calendarItems.forEach((item)=>{
        item.style.display = 'none';
    });
};
const $6dad9254e76b1584$var$showItem = (dateStr)=>{
    const matchingItems = document.querySelectorAll('[data-date="' + dateStr + '"]');
    if (matchingItems) matchingItems.forEach((item)=>{
        item.style.display = 'block';
    });
};
const $6dad9254e76b1584$var$updateUI = ()=>{
    const weekdayContainer = document.querySelector('.flatpickr-weekdaycontainer');
    const weekdays = weekdayContainer?.querySelectorAll('span');
    if (weekdays.length >= 7) {
        weekdays[0].innerText = 'M';
        weekdays[1].innerText = 'T';
        weekdays[2].innerText = 'O';
        weekdays[3].innerText = 'T';
        weekdays[4].innerText = 'F';
        weekdays[5].innerText = 'L';
        weekdays[6].innerText = 'S';
    }
};
function $6dad9254e76b1584$export$2e2bcd8739ae039() {
    const calendar = (0, $dd2925d3f317f2a9$export$2e2bcd8739ae039)($6dad9254e76b1584$var$calendarEl, {
        inline: true,
        enable: $6dad9254e76b1584$var$eventDates,
        locale: (0, $44d39541db003f03$exports.Swedish),
        monthSelectorType: 'static',
        nextArrow: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
        `,
        prevArrow: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg>
        `,
        onChange: (selecedDates, dateStr, instance)=>{
            $6dad9254e76b1584$var$hideInfoItem();
            $6dad9254e76b1584$var$hideAllItems();
            $6dad9254e76b1584$var$showEventSection();
            $6dad9254e76b1584$var$showItem(dateStr);
            if (window.innerWidth < 900) $6dad9254e76b1584$var$calendarEventSection.scrollIntoView();
        }
    });
    if ($6dad9254e76b1584$var$closeEventSection) $6dad9254e76b1584$var$closeEventSection.addEventListener('click', ()=>{
        calendar.clear();
        $6dad9254e76b1584$var$hideAllItems();
        $6dad9254e76b1584$var$showInfoItem();
    });
    if ($6dad9254e76b1584$var$calendarBlurbs.length > 0) $6dad9254e76b1584$var$calendarBlurbs.forEach((blurb)=>{
        if (blurb.hasAttribute('data-next')) blurb.addEventListener('click', ()=>{
            const next = blurb.getAttribute('data-next');
            calendar.setDate(next, true);
        });
    });
    $6dad9254e76b1584$var$updateUI();
}


/* eslint-disable prettier/prettier */ const $df17804dd84e7d44$var$blocksContainer = document.querySelector('.content-page--blocks');
const $df17804dd84e7d44$var$blockHeadings = $df17804dd84e7d44$var$blocksContainer?.querySelectorAll('h2');
const $df17804dd84e7d44$var$navigationList = document.querySelector('.content-page--navigation--list');
const $df17804dd84e7d44$var$cleanString = (string)=>{
    return string.replace(/[åä]/g, "a").replace(/ö/g, "o").replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "-").toLowerCase();
};
const $df17804dd84e7d44$var$setHeadingIds = ()=>{
    if ($df17804dd84e7d44$var$blockHeadings.length > 0) $df17804dd84e7d44$var$blockHeadings.forEach((item)=>{
        const id = $df17804dd84e7d44$var$cleanString(item.innerText);
        item.id = id;
    });
};
const $df17804dd84e7d44$var$setNavList = ()=>{
    if ($df17804dd84e7d44$var$blockHeadings.length > 0 && $df17804dd84e7d44$var$navigationList) $df17804dd84e7d44$var$blockHeadings.forEach((item)=>{
        const heading = item.innerText;
        const id = $df17804dd84e7d44$var$cleanString(heading);
        const listItem = document.createElement('li');
        const linkItem = document.createElement('a');
        linkItem.href = '#' + id;
        linkItem.innerText = heading;
        listItem.appendChild(linkItem);
        $df17804dd84e7d44$var$navigationList.appendChild(listItem);
    });
    else if ($df17804dd84e7d44$var$navigationList) $df17804dd84e7d44$var$navigationList.closest('.content-page--navigation--container')?.setAttribute('style', 'display: none;');
};
const $df17804dd84e7d44$var$initIsInView = ()=>{
    if ($df17804dd84e7d44$var$blockHeadings.length > 0) $df17804dd84e7d44$var$blockHeadings.forEach((item)=>{
        const itemlink = document.querySelector('a[href="#' + $df17804dd84e7d44$var$cleanString(item.innerText) + '"]');
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) itemlink.classList.add('in-view');
                else itemlink.classList.remove('in-view');
            });
        }, {
            threshold: 0.75
        }) //TODO:test on content and modify threshold if needed
        ;
        observer.observe(item.closest('.block'));
    });
};
function $df17804dd84e7d44$export$2e2bcd8739ae039() {
    $df17804dd84e7d44$var$setHeadingIds();
    $df17804dd84e7d44$var$setNavList();
    $df17804dd84e7d44$var$initIsInView();
}


(0, $79c742c8182c44e1$export$2e2bcd8739ae039).plugin((0, $d1d4bac008700b8f$export$2e2bcd8739ae039));
(0, $79c742c8182c44e1$export$2e2bcd8739ae039).start();
if (document.querySelector('.history-block')) (0, $486fa63a7f16da4a$export$2e2bcd8739ae039)();
if (document.querySelector('.calendar-block')) (0, $6dad9254e76b1584$export$2e2bcd8739ae039)();
if (document.querySelector('.content-page--container.with-navigation')) (0, $df17804dd84e7d44$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=main.js.map
